import { InputHTMLAttributes, FC, MouseEvent, KeyboardEvent } from 'react'
import { Container } from './styles'
import { OrangeButton } from '../index'
import { IoSearchOutline } from 'react-icons/io5'

interface FirmSearchInputProps extends InputHTMLAttributes<HTMLInputElement> {
  searchBtnDisabled?: boolean;
  onSearchClick: () => Promise<void>;
}

const FirmSearchInput: FC<FirmSearchInputProps> = ({ 
  searchBtnDisabled, 
  onSearchClick,
  ...inputProps 
}) => {
  const handleSearchClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
    onSearchClick()
  }  

  const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if(event.key === 'Enter') {
      onSearchClick()
    }
  }

  return (
    <Container>
      <IoSearchOutline />
      <input
        type="text"
        onKeyDown={handleKeyDown}
        {...inputProps}
      />
      <OrangeButton
        disabled={searchBtnDisabled}
        onClick={handleSearchClick}
        type="submit"
      >
        Search
      </OrangeButton>
    </Container>
  )
}

export default FirmSearchInput